module.exports = __webpack_public_path__ + "img/SW125_MemoryShare_Final-15.138172e6.png";